import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { PositionSettingsInterface } from '@shared/components/trading/widgets/positions-widget/core/interfaces/position-settings.interface'
import { DropdownColumnsPositionsComponent } from './dropdowns/dropdown-columns-positions/dropdown-columns-positions.component'

@Component({
	selector: 'app-positions-widget-actions',
	templateUrl: './positions-widget-actions.component.html',
	styleUrl: './positions-widget-actions.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [DropdownColumnsPositionsComponent],
})
export class PositionsWidgetActionsComponent {
	public widget: InputSignal<WidgetInterface<PositionSettingsInterface> | null> =
		input<WidgetInterface<PositionSettingsInterface> | null>(null)
}
